define([
    "jquery",
    "domReady!",
    "pubsub",
    "jquery.tooltipster",
    'promise!wcs.lang-msg'
    ], function($, domReady) {

        var DEBUG = false,
            PLUGIN_IDENTIFIER = "TooltipUtil",
            toolTipTheme,
            instance = null;

        try {
            // Using ZCG_CONFIG as a workaround until a structure for calling config variables is implemented
            // TODO: Implement new variable using implemented structure
            toolTipTheme = ZCG_CONFIG.TOOLTIP.TOOLTIP_THEME;
        } catch(err) {
            toolTipTheme = 'tooltipster-default';
        }

        var TooltipUtil = function() {
            if (instance === null){
                this.init();
            }
        };

        TooltipUtil.prototype = {
            ////////////////////////////////////////////////////
            // Initializers
            ////////////////////////////////////////////////////
            init: function () {
                if(DEBUG && console) console.log(PLUGIN_IDENTIFIER + ' init');

                if(window.UNIT_TEST_MODE) {
                    return this;
                }
                this.tooltipsterEvents();
                this.initTooltipsters();

                // Return the instance
                return this;
            },

            tooltipsterEvents: function() {
                var self = this;

                $.pubsub('subscribe', 'REINIT_TOOLTIPSTERS', function() {
                    self.initTooltipsters();
                });

                $.pubsub('subscribe', 'STICKYCART_TOOLTIPSTERS', function() {
                    self.initStickyCartTooltipster();
                });

                $(document).on('open', '#modal', '[data-reveal]', function() {
                    self.setupGuaranteeLinkTooltipster($('#quickview-box .product-content-form-guarantee-tooltip.link-button.tooltip-js'));
                });

                $.pubsub('subscribe', 'vfdp.wcs.product_list.ajax_product_loaded', function() {
                    var byPass = true;
                    self.initDefaultTooltipster(true);
                });

                $.pubsub('subscribe', 'vfdp.aem.topnav.dropdown', function() {
                    // close only the initialized tooltips
                    $('.tooltip-js').filter(function() {
                        return $(this).data('tooltipsterNs');
                    }).tooltipster('hide');
                });
            },

            initTooltipsters: function () {
                this.initPDPBadgeTooltipster();
                this.initPDPSwatchesProductImgTooltipster();
                this.initEGiftHelpTooltipster();
                this.initSecondaryProductActionTooltipster();
                this.initGuaranteeLinkTooltipster();
                this.initSellingFormSectionTooltipster();
                this.initTooltipCommon();
                this.initLoyaltySignupTooltipster();
                this.initCheckoutHeaderLogoTooltipster();
                this.initDefaultTooltipster(); // initDefaultTooltipster() should remain the last tooltipster init call
            },

            initPDPBadgeTooltipster: function() {
                var self = this,
                    $PDPBadgeTooltipster = $('.product-content-form-guarantee-tooltip.tooltip-js');

                if ($PDPBadgeTooltipster.hasClass('tooltipstered')) {
                    return;
                }

                self.setupGuaranteeLinkTooltipster($PDPBadgeTooltipster);
            },

            setupGuaranteeLinkTooltipster: function($link) {
                var offsetY = 0;
                // If the product form is inside a reveal modal we need to take into account the scroll position of the body
                if ($link.closest('.reveal').length) {
                    offsetY = parseInt($('html').css('top'), 10);
                }

                $link.tooltipster({
                    contentAsHTML: true,
                    animation: 'fade',
                    trigger: 'click',
                    position: 'top',
                    interactive: true,
                    minWidth : 300,
                    maxWidth: 300,
                    theme: 'tooltipster-light',
                    offsetY: offsetY,
                    multiple: true
                });
            },

            initPDPSwatchesProductImgTooltipster: function() {
                var $PDPSwatchesProductImgTooltipster = $('.pdp-swatches #product-imgs img.tooltip-js');

                if ($PDPSwatchesProductImgTooltipster.hasClass('tooltipstered')){
                    return;
                }

                $PDPSwatchesProductImgTooltipster.on('mouseout',function(e) {
                        e.stopPropagation();
                        var self = $(e.target);
                        setTimeout(function(){
                            self.tooltipster('hide');
                        }, 6000);
                    }).tooltipster({
                        contentAsHTML: true,
                        animation: 'fade',
                        trigger: 'click',
                        position: 'right',
                        interactive: true,
                        theme: 'tooltipster-light'
                    });
            },

            initSecondaryProductActionTooltipster: function() {
                var $secondaryProductActionTooltipster = $('.pdp-swatches .product-actions-secondary .tooltip-js');

                if ($secondaryProductActionTooltipster.hasClass('tooltipstered')) {
                    return;
                }

                $secondaryProductActionTooltipster.tooltipster({
                    contentAsHTML: true,
                    animation: 'fade',
                    trigger: 'click',
                    position: 'right',
                    interactive: true,
                    multiple: true,
                    theme: 'tooltipster-light'
                });
            },

            initEGiftHelpTooltipster: function() {
                var $eGiftToolTip = $('.egift-link-tooltip.tooltip-js');

                $eGiftToolTip.tooltipster({
                    contentAsHTML: true,
                    animation: 'fade',
                    trigger: 'click',
                    minWidth : 300,
                    maxWidth: 300,
                    position: 'top',
                    forcePosition: false,
                    interactive: true,
                    multiple: true,
                    theme: 'tooltipster-light'
                });
            },

            initGuaranteeLinkTooltipster: function() {
                var anchorTooltipEventsBinded = false,
                    $anchorTooltip = $('.pdp-swatches #product-form a.tooltip-js');

                if ($anchorTooltip.hasClass('tooltipstered')) {
                    return;
                }

                $anchorTooltip.tooltipster({
                    contentAsHTML: true,
                    animation: 'fade',
                    trigger: 'custom',
                    position: 'left',
                    interactive: true,
                    theme: 'tooltipster-light',
                    functionReady: function() {
                        if (anchorTooltipEventsBinded === false) {
                            anchorTooltipEventsBinded = true;
                            $anchorTooltip.on('mouseout click hover mouseover', function(e) {
                                $anchorTooltip.tooltipster('enable');
                            });
                        }
                    }
                });
            },

            initSellingFormSectionTooltipster: function() {
                var $sellingFormSectionTooltipster = $('#selling-form-section-js .tooltip-js');
                if ($sellingFormSectionTooltipster.hasClass('tooltipstered')) {
                    return;
                }

                $sellingFormSectionTooltipster.tooltipster({
                    contentAsHTML: true,
                    multiple: true,
                    animation: 'fade',
                    trigger: 'click',
                    interactive: true,
                    theme: toolTipTheme,
                    functionReady: function() {
                        $('.tooltipClose').on('click', function() {
                            $('.tooltip-js').tooltipster('hide');
                        });
                    }
                });
            },

            initTooltipCommon: function() {
                // Excludes tooltips that have already been tooltipstered
                var $tooltipCommon = $('.tooltip-common.tooltip-js').not('.tooltipstered');

                /*Added to prevent scrolling to top of page on click of tooltip*/
                $tooltipCommon.on('click', function(event) {
                    event.preventDefault();
                    var $this = $(this);

                    if ($this.attr('aria-expanded') === 'false') { // tooltip is closed
						$this.attr('aria-expanded', 'true');
					} else { //tooltip is open
						$this.attr('aria-expanded', 'false');
                    }
                }).tooltipster({
                    contentAsHTML: true,
                    multiple: true,
                    animation: 'fade',
                    trigger: 'click',
                    interactive: true,
                    trackTooltip: true,
                    theme: '.tooltipster-shadow',
                    functionBefore: function(origin, continueTooltip) {
                        continueTooltip();
                        var labelClose = LANG_MSG['MODAL.LABELS.CLOSE'] || "close";
                        $('.tooltipster-content')
                            .find('img').on('load', function() {
                                origin.tooltipster('reposition');
                            })
                            .end()
                            .append('<div class="tooltipCloseBtn"><button class="tooltipClose">' + labelClose + '</button></div>')
                            .parent().addClass('tooltipster-common');

                        origin.tooltipster('reposition');

                        $('.tooltipClose').on('click', function() {
                            $tooltipCommon.tooltipster('hide').attr('aria-expanded', 'false');

                        });
                        // Focusable Elements inside of tooltipster
                        var focusableEls = $('.tooltipster-content').find('a[href]:not(:disabled), button:not(:disabled)');
                        //Focus on first focusable element inside of tooltipster content
                        focusableEls[0].focus();
                    },
                    functionReady: function(instance){
                        //Visa Checkout ToolTip
                        if (instance.hasClass('visacheckout-tooltip') && WCS_CONFIG.get('checkout::visaCheckoutEnabled')) {
                            $.pubsub('publish', 'VISA_CHECKOUT_CONTENT_READY');
                        }
                    },
                    functionAfter: function(instance) {
                        // Tooltip closes, put focus back on initiator of Tooltip
                        instance.focus();
                    }
                });
            },

            initLoyaltySignupTooltipster: function() {
                var $loyaltySignupTooltipster = $('.tooltip-loyalty-signup.tooltip-js');

                if ($loyaltySignupTooltipster.hasClass('tooltipstered')) {
                    return;
                }

                $loyaltySignupTooltipster.tooltipster({
                    contentAsHTML: true,
                    multiple: true,
                    animation: 'fade',
                    trigger: 'click',
                    interactive: true,
                    maxWidth: 310,
                    theme: toolTipTheme
                });
            },

            initCheckoutHeaderLogoTooltipster: function() {
                var $checkoutHeaderLogoTooltipster = $('.checkout-header-logo-tooltip.tooltip-js');

                if ($checkoutHeaderLogoTooltipster.hasClass('tooltipstered')) {
                    return;
                }

                $checkoutHeaderLogoTooltipster.tooltipster({
                    contentAsHTML: true,
                    trackTooltip: true,
                    animation: 'fade',
                    trigger: 'click',
                    interactive: true,
                    theme: '.tooltipster-shadow tooltipster-checkout-header-alert',
                    functionReady: function(origin) {

                        $('.close-tooltip').on('click', function() {
                            $checkoutHeaderLogoTooltipster.tooltipster('hide');
                        });
                    }
                });
            },

            initStickyCartTooltipster: function() {
                var $stickBarTooltip = $('.sticky-add-to-cart .product-content-form-guarantee-tooltip.tooltip-js');
                var offsetY = 0;

                // If the product form is inside a reveal modal we need to take into account the scroll position of the body
                if ($stickBarTooltip.closest('.reveal').length) {
                    offsetY = parseInt($('html').css('top'), 10);
                }

                $stickBarTooltip.tooltipster({
                    contentAsHTML: true,
                    animation: 'fade',
                    trigger: 'click',
                    position: 'top',
                    interactive: true,
                    minWidth : 300,
                    maxWidth: 300,
                    theme: 'tooltipster-light',
                    offsetY: offsetY,
                    multiple: true
                });
            },

            // passing true to initDefaultTooltipster will by pass
            // the class check for content that is copied and re-injected
            // into the dom. See _tooltipsterEvents for this being used.
            initDefaultTooltipster: function(byPass) {
                var self = this,
                    $tooltip = $('.tooltip-js');

                if ($tooltip.hasClass('tooltipstered') && !byPass) {
                    return;
                }

                $tooltip.tooltipster({
                    contentAsHTML: true,
                    multiple: true,
                    animation: 'fade',
                    trigger: 'click',
                    interactive: true,
                    //theme: toolTipTheme
                    theme: toolTipTheme,
                    functionBefore: function(origin, continueTooltip){
                        continueTooltip();

                        if($('#account, #myaccount').length > 0){
                            self.initMyAccountTooltip();
                        }
                    }
                });
            },

            initMyAccountTooltip: function() {
                $('img', '.tooltipster-content').on('load',function() {
                    origin.tooltipster('reposition');
                });

                $('.tooltip-close-js').on('click', function(e) {
                    e.preventDefault();
                    $('.tooltip-js').tooltipster('hide');
                });
            }
        };

        TooltipUtil.getInstance = function(){
            if (instance === null){
                instance = new TooltipUtil();
            }

            return instance;
        };

        return TooltipUtil.getInstance();

    } // Close Require.JS wrapper
); // Close Require.JS wrapper
